/**
 * Filtros da lista do Registro de Aulas.
 *
 * Achar um registro específico era rolar o mês aula por aula — e, sem saber
 * o mês, abrir mês por mês. Com um filtro ativo a lista passa a mostrar o
 * ano inteiro da disciplina (o Diário pede `?year=` em vez de `?month=`), e
 * estes filtros recortam o que aparece.
 */

import { includesAllWords } from './normalizeText';
import { aulaResolvida, aulaSemConteudo } from './aulasDoDia';

export const FILTROS_VAZIOS = { busca: '', tipo: '', aula: '', situacao: '' };

// Não é um `lesson_type`: é a aula registrada num horário que a grade dá a
// outra disciplina (`horario_de`, do backend) — a substituição de fato,
// qualquer que seja o tipo escolhido no registro.
export const TIPO_HORARIO_DE_OUTRA = 'horario_de_outra';

export const SITUACOES = [
  { value: 'concluida', label: 'Concluída' },
  { value: 'falta_conteudo', label: 'Falta conteúdo' },
  { value: 'falta_frequencia', label: 'Falta frequência' },
];

export const filtrosAtivos = (filtros) =>
  Object.values(filtros || {}).some((valor) => String(valor || '').trim() !== '');

function situacaoConfere(entry, situacao) {
  const naoRealizada = entry.lesson_type === 'nao_realizada';
  if (situacao === 'concluida') return aulaResolvida(entry) && !naoRealizada;
  if (situacao === 'falta_conteudo') return aulaSemConteudo(entry);
  if (situacao === 'falta_frequencia') return !entry.attendance_filled && !naoRealizada;
  return true;
}

/** Os registros que passam em todos os filtros preenchidos. */
export function filtrarRegistros(entries, filtros) {
  const { busca, tipo, aula, situacao } = { ...FILTROS_VAZIOS, ...filtros };
  return (entries || []).filter((entry) => {
    if (tipo === TIPO_HORARIO_DE_OUTRA) {
      if (!entry.horario_de) return false;
    } else if (tipo && entry.lesson_type !== tipo) {
      return false;
    }
    if (aula && String(entry.class_period || '') !== String(aula)) return false;
    if (situacao && !situacaoConfere(entry, situacao)) return false;
    if (busca) {
      // Conteúdo, BNCC, observações, componente e motivo: o que a pessoa
      // lembra da aula ("frações", "EF69AR01", "passeio").
      const texto = [
        entry.content_description, entry.bncc_skills, entry.observations,
        entry.componente_name, entry.not_held_reason,
      ].filter(Boolean).join(' ');
      if (!includesAllWords(texto, busca)) return false;
    }
    return true;
  });
}

/** As aulas do dia (1ª, 2ª...) que aparecem nos registros, em ordem. */
export const aulasDosRegistros = (entries) =>
  [...new Set((entries || []).map((e) => e.class_period).filter(Boolean))].sort((a, b) => a - b);
